import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Auth.css';

const SignUp = () => {
  const { loginWithGoogle, loginWithLinkedIn } = useAuth();

  return (
    <div className="signup-container">
      <div className="signup-layout">
        {/* Left Column - Image */}
        <div className="signup-image-column">
          <img 
            src="https://cshmhfxwounurylautnc.supabase.co/storage/v1/object/public/scanmaster-logo/ParrotSEO.png" 
            alt="Parrot SEO" 
            className="signup-image"
          />
        </div>

        {/* Right Column - Signup Form */}
        <div className="signup-form-column">
          <div className="signup-form-wrapper">
            <div className="auth-header">
              <h1 className="auth-title">Create Account</h1>
              <p className="auth-subtitle">Sign up to start using Parrot SEO</p>
            </div>

            <div className="auth-form">
              {/* SSO Buttons */}
              <div className="sso-buttons">
                <button
                  type="button"
                  className="sso-button google"
                  onClick={loginWithGoogle}
                >
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.64 9.20454C17.64 8.56636 17.5827 7.95272 17.4764 7.36363H9V10.845H13.8436C13.635 11.97 13.0009 12.9232 12.0477 13.5614V15.8195H15.6564C16.7091 14.7773 17.64 13.1318 17.64 9.20454Z" fill="#4285F4"/>
                    <path d="M9 18C11.43 18 13.467 17.1941 14.9564 15.8195L11.3477 13.5614C10.4836 14.1014 9.34591 14.4204 9 14.4204C6.65409 14.4204 4.67182 12.8373 3.96273 10.71H0.285455V13.0418C1.76364 15.9832 4.81818 18 9 18Z" fill="#34A853"/>
                    <path d="M3.96273 10.71C3.78273 10.17 3.68182 9.59318 3.68182 9C3.68182 8.40681 3.78273 7.83 3.96273 7.29V4.95818H0.285455C-0.0954545 5.88818 -0.318182 6.91818 -0.318182 8.04545C-0.318182 9.17272 -0.0954545 10.2027 0.285455 11.1327L3.96273 10.71Z" fill="#FBBC05"/>
                    <path d="M9 3.57955C10.3218 3.57955 11.5077 4.03364 12.4405 4.92545L15.0218 2.34409C13.4632 0.891818 11.4259 0 9 0C4.81818 0 1.76364 2.01682 0.285455 4.95818L3.96273 7.29C4.67182 5.16273 6.65409 3.57955 9 3.57955Z" fill="#EA4335"/>
                  </svg>
                  Continue with Google
                </button>
                <button
                  type="button"
                  className="sso-button linkedin"
                  onClick={loginWithLinkedIn}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.447 20.452H16.893V14.883C16.893 13.555 16.866 11.846 15.041 11.846C13.188 11.846 12.905 13.291 12.905 14.785V20.452H9.351V9H12.765V10.561H12.811C13.288 9.661 14.448 8.711 16.181 8.711C19.782 8.711 20.448 11.081 20.448 14.166V20.452H20.447ZM5.337 7.433C4.193 7.433 3.274 6.507 3.274 5.367C3.274 4.224 4.194 3.305 5.337 3.305C6.477 3.305 7.397 4.224 7.397 5.367C7.397 6.507 6.478 7.433 5.337 7.433ZM7.119 20.452H3.555V9H7.119V20.452ZM22.225 0H1.771C0.792 0 0 0.774 0 1.729V22.271C0 23.227 0.792 24 1.771 24H22.222C23.2 24 24 23.227 24 22.271V1.729C24 0.774 23.2 0 22.222 0H22.225Z" fill="#0077B5"/>
                  </svg>
                  Continue with LinkedIn
                </button>
              </div>
            </div>

            <div className="auth-footer">
              <p>
                Already have an account? <Link to="/signin">Sign in</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;

